/**
 * 将前面的裁图前缀,参数以及协议头去掉
 * @param {*} url 要清洗的 url
 * @return {String} url
 */
const clear = (url) => {
    try {
        if (!url) {
            return url;
        }
        if (url.includes('d.ifengimg.com/')) {
            url = url.split('d.ifengimg.com/').pop();
            const paths = url.split('/');

            paths.shift();
            url = paths.join('/');
        }

        if (url.includes('http://')) {
            url = url.substring(7);
        }

        if (url.includes('https://')) {
            url = url.substring(8);
        }

        if (url.includes('//')) {
            url = url.substring(2);
        }

        return url;
    } catch (error) {
        console.error(error);

        return url;
    }
};

const ifengImgDomain = [
    'y0.ifengimg.com',
    'y1.ifengimg.com',
    'y2.ifengimg.com',
    'y3.ifengimg.com',
    'm0.ifengimg.com',
    'm1.ifengimg.com',
    'm2.ifengimg.com',
    'm3.ifengimg.com',
    'img.ifeng.com',
    'mimg.ifeng.com',
    's0.mimg.ifeng.com',
    's1.mimg.ifeng.com',
    's2.mimg.ifeng.com',
    's3.mimg.ifeng.com',
    's4.mimg.ifeng.com',
    'a0.ifengimg.com',
    'a1.ifengimg.com',
    'a2.ifengimg.com',
    'a3.ifengimg.com',
    's0.ifengimg.com',
    's1.ifengimg.com',
    's2.ifengimg.com',
    's3.ifengimg.com',
    'res.ent.ifeng.com',
    'res.news.ifeng.com',
    'res.fashion.ifeng.com',
    'blogfile.ifeng.com',
    'entimg.ifeng.com',
    'res.health.ifeng.com',
    'res.book.ifeng.com',
    'imgs.diantai.ifeng.com',
    'img.ugc.ifeng.com',
    'img1.ugc.ifeng.com',
    'res.phtv.ifeng.com',
    'bbsfile.ifeng.com',
    'res.img.ifeng.com',
    'c0.ifengimg.com',
    'c1.ifengimg.com',
    'p0.ifengimg.com',
    'p1.ifengimg.com',
    'p2.ifengimg.com',
    'p3.ifengimg.com',
    'q0.ifengimg.com',
    'p0.iikuzhan.com',
    'yj.fcai.com',
    'my.ifengimg.com',
    'sy.ifeng.com',
    'c0.fengshows.com',
    'c1.fengshows.com',
    'p0.fengshows.com',
    'p1.fengshows.com',
    'p2.fengshows.com',
    'p3.fengshows.com',
    'y0.fengshows.com',
    'y1.fengshows.com',
    'y2.fengshows.com',
    'y3.fengshows.com',
    'e0.ifengimg.com'
];

/**
 * 判断域名是否为公司的
 * @param {string} url
 * @return {Boolean} bool
 */
const checkDomain = (url) => {
    try {
        if (!url) {
            return url;
        }
        const domain = url.split('/')[0];

        if (ifengImgDomain.includes(domain)) return true;

        return false;
    } catch (error) {
        console.error(error);

        return false;
    }
};

/**
 * 裁剪图片方法
 * @param {string} url 系统提供的图片地址
 * @param {number} width 图片裁切宽度
 * @param {number} height 图片裁切高度
 * @param {number} quality 图片裁切质量，默认70，最大值100，一般可以不填，不建议写100
 * @return {String} url
 */
const formatImage = (url, width, height, quality = 70) => {
    try {
        if (!url) {
            return url;
        }
        url = clear(url.trim());

        if (!checkDomain(url)) return `//${url}`;

        const params = [];

        if (width) {
            params.push(`w${width}`);
        }

        if (height) {
            params.push(`h${height}`);
        }

        if (quality) {
            params.push(`q${quality}`);
        }

        return `//d.ifengimg.com/${params.join('_')}/${clear(url)}`;
    } catch (error) {
        console.error(error);

        return url;
    }
};

module.exports = formatImage;



// WEBPACK FOOTER //
// ./app/modules/relatedNews/formatImg.js